import constants from './constants'

const initState = {
    survey: {
        data: [],
        loading: false,
        error: {}
    },
    surveyResponse: {
        data: {
            surveyKey: "",
            stayGuid: "",
            answers: []
        },
        loading: false,
        apiResponseSuccess: false
    },
    logoResponse: {
        locationLogo: null,
        hideElimiWaitLogo: null,
    }
};


export default function reducer(state = initState, action) {
    switch (action.type) {

        case constants.GET_SURVEY:
            return {
                ...state,
                survey: {
                    data: [],
                    loading: true,
                    error: {}
                }
            };
        case constants.GET_SURVEY_SUCCESS:
            return {
                ...state,
                survey: {
                    data: action.data,
                    loading: false,
                    error: {}
                },
                logoResponse: {
                    locationLogo: action.data.LocationLogo,
                    hideElimiWaitLogo: action.data.HideElimiWaitLogo,
                }
            };
        case constants.GET_SURVEY_FAILED:
            return {
                ...state,
                survey: {
                    data: [],
                    loading: false,
                    error: action.error
                }
            };

        case constants.SET_URL_DATA:
            return {
                ...state,
                surveyResponse: {
                    data: {
                        surveyKey: action.surveyKey,
                        stayGuid: action.stayGuid,
                        answers: state.surveyResponse.data.answers
                    },
                    loading: false,
                    apiResponseSuccess: false
                }
            };


        case constants.SEND_SURVEY_RESULT:
            return {
                ...state,
                surveyResponse: {
                    data: {
                        surveyKey: state.surveyResponse.data.surveyKey,
                        stayGuid: state.surveyResponse.data.stayGuid,
                        answers: state.surveyResponse.data.answers
                    },
                    loading: true,
                    apiResponseSuccess: false
                }
            };
        case constants.SEND_SURVEY_RESULT_SUCCESS:
            return {
                ...state,
                surveyResponse: {
                    data: state.surveyResponse.data,
                    loading: false,
                    apiResponseSuccess: action.data
                }
            };
        case constants.SEND_SURVEY_RESULT_FAILED:
            return {
                ...state,
                surveyResponse: {
                    data: state.surveyResponse.data,
                    loading: false,
                    apiResponseSuccess: false
                }
            };

        case constants.UPDATE_ANSWER:
            let alreadyExists = state.surveyResponse.data.answers.find(x => x.questionId === action.questionId)
            let answer = { questionId: action.questionId, answerId: action.answerId, value: action.value }

            if (alreadyExists === undefined) {
                return {
                    ...state,
                    surveyResponse: {
                        data: {
                            answers: [...state.surveyResponse.data.answers, answer],
                            surveyKey: state.surveyResponse.data.surveyKey,
                            stayGuid: state.surveyResponse.data.stayGuid
                        },
                        loading: state.surveyResponse.loading,
                        apiResponseSuccess: state.surveyResponse.apiResponseSuccess
                    }
                }
            } else {
                let updatedAnswers = [];
                state.surveyResponse.data.answers.forEach(element => {
                    if (element.questionId === action.questionId) {
                        if (answer.value !== "") // don't add unless its has value (for shortText questions)
                            return updatedAnswers.push(answer);
                    } else
                        return updatedAnswers.push(element);
                });
                return {
                    ...state,
                    surveyResponse: {
                        data: {
                            answers: updatedAnswers,
                            surveyKey: state.surveyResponse.data.surveyKey,
                            stayGuid: state.surveyResponse.data.stayGuid
                        },
                        loading: state.surveyResponse.loading,
                        apiResponseSuccess: state.surveyResponse.apiResponseSuccess
                    }
                }
            }
        default: return state;
    }
}
